import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = {
  key: 1,
  class: "widget__warning"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Widget = _resolveComponent("Widget")!
  const _component_WidgetSettings = _resolveComponent("WidgetSettings")!

  return (_ctx.compCoords)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        (_ctx.widgetShow)
          ? (_openBlock(), _createBlock(_component_Widget, {
              key: 0,
              cities: _ctx.getCities,
              onShowWidget: _ctx.widgetVisibleToggler
            }, null, 8, ["cities", "onShowWidget"]))
          : (_openBlock(), _createBlock(_component_WidgetSettings, {
              key: 1,
              cities: _ctx.getCities,
              onAddCity: _ctx.addCity,
              onRemoveCity: _ctx.deleteCity,
              onDragCities: _cache[0] || (_cache[0] = (val = []) => _ctx.getCities = val),
              onShowWidgetSettings: _ctx.widgetVisibleToggler
            }, null, 8, ["cities", "onAddCity", "onRemoveCity", "onShowWidgetSettings"]))
      ]))
    : (_openBlock(), _createElementBlock("p", _hoisted_2, "Your geolocation is blocked or no data! Please, unblock geolocation and refresh the page!"))
}